import { Component, OnInit, ViewChild, OnDestroy, ViewContainerRef, Output, EventEmitter, OnChanges, Input } from '@angular/core';
import {DemoService} from '../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

// ag- table component

import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
// import { CustomiszedCellComponent } from '../customiszed-cell/customiszed-cell.component';
// import { CustomCellJobTypeComponent } from '../custom-cell-job-type/custom-cell-job-type.component';
// import { CustomCellJobLinkComponent } from '../custom-cell-job-link/custom-cell-job-link.component';
// import { CustomCellDateComponent } from '../custom-cell-date/custom-cell-date.component';

// 

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter, PdfExportService, PageService, SearchSettingsModel, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs, FilterType } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { delay } from 'rxjs';

import { FilterService, IFilterUI, Column, DateFilterUI } from '@syncfusion/ej2-angular-grids';
import { DatePicker, DateRangePicker } from '@syncfusion/ej2-calendars';
import { EditService, SortService,  SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { DataUtil } from '@syncfusion/ej2-data'; 
import { ButtonComponent } from '@syncfusion/ej2-angular-buttons';


import { parentsUntil } from '@syncfusion/ej2-grids';
import { pipe, Observable, Subject, map } from 'rxjs';
import { MysqlService } from './../../services/mysql.service';

// import {JobsAgentUpdateRequestComponent} from './../../ jobs-agent-update-request/jobs-agent-update-request.component';
import { GlobalFunctionsService } from './../../services/global-functions.service';
@Component({
  selector: 'app-client-job-status-key-widget',
  templateUrl: './client-job-status-key-widget.component.html',
  styleUrls: ['./client-job-status-key-widget.component.scss']
})
export class ClientJobStatusKeyWidgetComponent implements OnInit {




// added to be included as a component as well
@Input() item_id?; // impliments on changes.
@Input() item_data?; // if data.model is sent : Observable<any[]>;
@Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
@Input() item_user_level_id? = '5'; // default to agent just in case
@Input() item_brand_type_id? = '';
@Input() show_buttons? = 'no'; // yes | no
@Input() widget_title? = '';
@Input() widget_size? = 'full'; // side | abstract | full


  job_table: any;
  result: any;
  client_name: any;
  persons: any;
  job_table2: any;
  client_name_value: any;
 responseDelay = 2000;
  clients: any;
  clientLocalRecord: any;
  job_types: any;
  subjects: any;
  agents_assigned: any;
  staffList: any;
  items: Object[];
  data_subjects2: any;
  initialPage: PageSettingsModel;

  jobTypesLocalRecord: any;
  changeObject: any;

  subjectLocalRecord: any;

  createdAt: any;
  nextDateLocalRecord: any;

  agentsAssignedLocalRecord: any;
  allocated_agents_list: any;

  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public filterOptions_2022: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[] | object;
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;

  job_table3: any; // filtered results of job table2 to load properly
  brands: any;
  brandsLocalRecord: any;
  brandLocalRecord: any;
  subject_agents_assigned: any;
  subjectsAssignedLocalRecord: any;
  allocated_agents_subject_list: any;
  brandAgentsList: any;
  assignedBrandList: any;
  public toolbar: ToolbarItems[] | object;

  search_results: any;
  search_results_processed: Array<{subject_id: number, email_sent: string}> = [];



  filterSettings: Object;
  public templateOptions: IFilter;
  public dateRangePicker: DateRangePicker;


// Evemt Emmitter to child Component
  eventsSubject: Subject<void> = new Subject<void>();
  search_resultsO: any;
  subject_sent: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  brand_id: any;
  subject_id: any;
  get_latest_subject_note_id: Object;
  sessionUserUserName: any;
  sr: any;
  subjects_urgent: any;
  formatoptions: { type: string; format: string; };
  dateFormat: string;

  today = new Date();

  sessionUsername: any;
  all_router_details: string;
  subjects_urgent_table: any;
  assignedAgentsList: any;
  allRecipients: any;
  assigned_to_agents: string;
  user_levels: Object;
  brand_types: Object;
  brand_user_join_results: any[];
  brand_search: Object;
  brand_search_results: any;
  user_search: Object;
  user_search_results: any;
  users: Object;
  usersPrimary: Object;
  todaySetFormat: any;
  rule_text_OPEN: string;
  rule_email_text_OPEN: any;
  rule_text_UPDREQ: string;
  rule_email_text_UPDREQ: string;
  selectedrecords: Object[];
  rule_text_UPDSENT: string;
  rule_email_text_UPDSENT: string;
  rule_text_AOA: string;
  rule_email_text_AOA: string;
  job_status: any;

  constructor(
    private http: HttpClient, private router: Router, route: ActivatedRoute, private _demoService: DemoService,
    public datepipe: DatePipe,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private _mysqlService: MysqlService, 
    public gfunc: GlobalFunctionsService
  ) {

    // Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

   }

  ngOnInit(): void {

    this.getJobStatusNames();
  }



  private getJobStatusNames() {
    this._demoService.getJobStatusNames()
      .subscribe(
        res => this.job_status = res,
        err => console.error(err.status)
      );
  }

}
